export const loomQrUrl = (loomCode: string) => {
  const origin =
    process.env.REACT_APP_LOC_URL ||
    process.env.REACT_APP_DEV_URL ||
    window.location.origin;
  return `${String(origin).replace(/\/$/, "")}/loom/${loomCode}`;
};

export const parsePublicLoomCode = (pathname: string): string => {
  const parts = String(pathname || "")
    .split("/")
    .filter(Boolean);
  const idx = parts.indexOf("loom");
  if (idx < 0 || !parts[idx + 1]) {
    return "";
  }
  try {
    return decodeURIComponent(parts[idx + 1]);
  } catch {
    return parts[idx + 1];
  }
};

export const copyText = async (text: string): Promise<boolean> => {
  if (!text) {
    return false;
  }
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "fixed";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(el);
      return ok;
    } catch {
      return false;
    }
  }
};
